import { jsx as r, jsxs as m, Fragment as i } from "react/jsx-runtime";
import { DeletedContent as p } from "../../../DeletedContent/index.js";
import { ParentComment as d } from "../../../ParentComment/index.js";
import { ParentCommentWrapper as C, ContentWrapper as f } from "./style.js";
import { CommentContentRenderer as c } from "../../../CommentContentRenderer/index.js";
const j = ({
  isDeleted: t,
  parentComment: e,
  content: n,
  clickoutFunction: o
}) => t ? /* @__PURE__ */ r(p, {}) : /* @__PURE__ */ m(i, { children: [
  e && /* @__PURE__ */ r(C, { children: /* @__PURE__ */ r(d, { ...e }) }),
  /* @__PURE__ */ r(f, { children: /* @__PURE__ */ r(c, { clickoutFunction: o, children: n }) })
] });
export {
  j as CommentContentBody
};
